module.exports = __webpack_public_path__ + "img/JourneySoFar.f20d9e17.png";